import { render, staticRenderFns } from "./ReceptionApplicantView.vue?vue&type=template&id=26637add&scoped=true&"
import script from "./ReceptionApplicantView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionApplicantView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26637add",
  null
  
)

export default component.exports